var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCulture = function SvgCulture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 71.62"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.97 71.28 44.03.34V.33L42.71 0v33.97L19.97 46.74z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.05 20.71v32.35l18.01 10.12c1.22.68 2.7.68 3.92 0l18.01-10.12V20.71zm21.27 9.69H47c.05.08.1.16.13.26.51 1.86 2.01 3.11 3.73 3.11s3.22-1.25 3.73-3.11c.03-.1.08-.18.13-.26h1.68c.14.23.2.51.12.79-.74 2.69-3.07 4.58-5.66 4.58s-4.92-1.88-5.66-4.58a.99.99 0 0 1 .12-.79m11.06 20.63a1.5 1.5 0 0 1-2.12-.02c-2.72-2.77-6.35-4.3-10.24-4.3s-7.52 1.53-10.24 4.3a1.5 1.5 0 0 1-2.14-2.1c3.29-3.35 7.68-5.2 12.38-5.2s9.09 1.85 12.38 5.2a1.5 1.5 0 0 1-.02 2.12",
    style: {
      clipPath: "url(#a)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0v32.35l18.01 10.12c1.22.68 2.7.68 3.92 0l18.01-10.12V0zm21.36 13.28c.74-2.7 3.07-4.58 5.66-4.58s4.92 1.88 5.66 4.58c.08.28.02.56-.12.79h-1.68c-.05-.08-.1-.16-.13-.26-.51-1.86-2.01-3.11-3.73-3.11s-3.23 1.28-3.73 3.11c-.03.1-.07.18-.12.26h-1.69a.99.99 0 0 1-.12-.79m-14.1 0c.74-2.7 3.07-4.58 5.66-4.58s4.92 1.88 5.66 4.58c.08.28.02.56-.12.79h-1.69c-.05-.08-.09-.16-.12-.26-.5-1.83-2.04-3.11-3.73-3.11s-3.22 1.25-3.73 3.11c-.03.1-.08.18-.13.26H7.38a.99.99 0 0 1-.12-.79m25.09 13.64c-3.29 3.35-7.68 5.2-12.38 5.2s-9.09-1.85-12.38-5.2a1.5 1.5 0 0 1 2.14-2.1c2.72 2.77 6.35 4.3 10.24 4.3s7.52-1.53 10.24-4.3a1.5 1.5 0 0 1 2.14 2.1"
  })));
};
export default SvgCulture;